// Select the nth 2D matrix from an array of 2D arrays (rotation states)
export function rotateMatrix(patterns: number[][][], rotation: number): number[][] {
  return patterns[rotation % patterns.length];
} 